import axios from '@axios'
import Swal from 'sweetalert2'

export function ServicePrescription() {
  this.fetchPrescriptionModelo = async params => new Promise((resolve, reject) => {
    axios.get('prescriptions/all', { params })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.createPrescription = async data => new Promise((resolve, reject) => {
    axios.post('prescriptions/create', data)
      .then(resp => {
        Swal.fire({
          icon: 'success',
          title: 'Prescrição criada com sucesso',
          text: resp.data.message,
        })
        resolve(resp)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao criar prescrição',
          text: err.response.data.message,
        })
        reject(err)
      })
  })

  this.deletePrescription = async query => {
    axios.delete('prescriptions/delete', { params: query })
      .then(resp => {
        Swal.fire({
          icon: 'success',
          title: 'Prescrição deletada com sucesso',
          text: resp.data.message,
        })
        return resp
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao deletar prescrição',
          text: err.response.data.message,
        })
        // console.log('Erro ao deletar prescrição:', err)
      })
  }

  this.updatePrescription = async (id, data) => new Promise((resolve, reject) => {
    axios.put(`prescriptions/update/${id}`, data)
      .then(resp => {
        Swal.fire({
          icon: 'success',
          title: 'Prescrição atualizada com sucesso',
          text: resp.data.message,
        })
        resolve(resp)
      })
      .catch(err => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao atualizar prescrição',
          text: err.response.data.message,
        })
        reject(err)
      })
  })

  this.fetchMedicines = params => new Promise((resolve, reject) => {
    axios.get('bulario/pesquisar', { params })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao buscar bulário:', err)
        reject(err)
      })
  })
}
